import { render, staticRenderFns } from "./EventDashboard.vue?vue&type=template&id=44ae273a&"
import script from "./EventDashboard.vue?vue&type=script&lang=js&"
export * from "./EventDashboard.vue?vue&type=script&lang=js&"
import style0 from "./EventDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports